module.exports = __webpack_public_path__ + "static/media/sourcesanspro-regular-webfont.699e5f09.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-regular-webfont.woff2
// module id = 271
// module chunks = 0